// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"de76b6bbbf099d1887fa","655":"23ded02a07b7f0e4c1c2"}[chunkId] + ".js";
};